import { Button } from '@/components/ui/button';
import type { PricingItem } from '../api/settings';

interface SettingsBillingSectionProps {
  pricing: PricingItem[] | undefined;
  balanceFormatted: string;
  onAddFunds: () => void;
}

export function SettingsBillingSection({
  pricing,
  balanceFormatted,
  onAddFunds,
}: SettingsBillingSectionProps) {
  return (
    <>
      {/* Account Balance Section */}
      <section className="mb-8">
        <h2 className="mb-6 text-lg font-semibold text-[#051923]">Account Balance</h2>
        <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-4">
          <div>
            <p className="text-sm text-gray-600">Current Balance</p>
            <p className="text-2xl font-semibold text-[#051923]">{balanceFormatted}</p>
          </div>
          <Button
            type="button"
            onClick={onAddFunds}
            className="w-[200px] bg-[#131313] text-white hover:bg-[#131313]/90 sm:w-[330px]"
          >
            Add Funds
          </Button>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="mb-8">
        <h2 className="mb-6 text-lg font-semibold text-[#051923]">Pricing</h2>
        <div className="space-y-3">
          {pricing?.map((item) => (
            <div key={item.key} className="flex items-center justify-between">
              <span className="text-gray-700">{item.name}</span>
              <span className="font-medium text-[#051923]">
                £{parseFloat(item.priceGBP).toFixed(2)}
              </span>
            </div>
          ))}
        </div>
        <div className="mt-4 text-center">
          <button
            type="button"
            disabled
            className="cursor-not-allowed text-sm font-semibold text-gray-400 underline"
          >
            Download Last 30 Days Statement
          </button>
        </div>
      </section>
    </>
  );
}
